<template>
	<div class="whoarewe">
		<div class="Izquierda">
			<div class="headerWho" >
				<h1>Who we are</h1>
			</div>
			<div class="contenidoWho">
				<p>Founded in Mexico City in 1998, <span>Grupo Glarus</span> provides world-class security services to VIPs, and international and multinational companies who are doing business or traveling in Mexico.
				</p>
				<p>
				<span>Grupo Glarus</span> is on the short-list of security companies in Mexico that have been vetted by the U.S. State Department. We staff a 24x7 rapid reaction center, and can liaison with local authorities and foreign embassies in the event of an emergency.
				</p>
				<p>
				We understand the local culture and its challenges, as well as the needs, expectations and standards of our international clients. Our staff includes several bilingual agents.
				</p>
			</div>
		</div>

		<div class="Derecha">
			<img src="../assets/img/clientes_home.jpg" alt="">
		</div>
	</div>
</template>

<script>
export default {
	name: "WhoweareComponent",
	
	data: () => ({
		offsetTop: 0
	}),
	methods:{
		onScroll () {
			this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

@import url('../assets/less/soloVariables.less');

body, html{
	min-height: 100%;
}

.whoarewe{
	position: relative;
	//top: 80px;
	height: 100%;
	
	background-color: white;
	
	//padding: 10px 50px 0px 50px;

	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;

	.Izquierda{ 
		width: 50%;
		padding: 0px 20px;
		//background-color: green;

		@media @desktop-xl {
		}

		@media @desktop {
			width: 89%;
		}

		@media @tablet {
			width: 90%;
			//padding: 0px 10px;
		}

		@media @mobile {
			width: 95%;
		}
		
		
		.headerWho{
			padding-top: 60px;
			padding-bottom: 10px;
			h1{
				color: @color_Principal_Logo;
				
				width: 150px;
				font-weight:300;
				font-family: 'Raleway';
				font-size: 1.4em;
				padding: 15px;
				border-top: 1px solid @color_Secundario_Logo;
				border-bottom: 1px solid @color_Secundario_Logo;
			}
		}
		.contenidoWho{
			color: grey;
			span{
				font-weight: bold;
				color: grey;
				font-size: 1.3em;
			}
		}
	} // Izquierda
	
	.Derecha{
		width: 534px;
		//background-color: red;
		padding: 0px 10px;
		img{
			display: block;
			height: 627px;
			margin: auto;
			@media @tablet {
				height: 427px;
			}
			@media @mobile {
				margin: auto;
				height: 227px;
			}
		}

		@media @tablet {
			padding: 0px 10px;
		}
		@media @mobile {
			padding: 0px 0px;
		}
		
		//background-image: url(../assets/img/clientes_home.jpg);
		// background-repeat: no-repeat;
		//background-size: cover;
		// background-position: center;

	} // Derecha
} // Whoweare

</style>
